/** Production survey URLs for QR codes (always public app host). */
export const SURVEY_APP_ORIGIN = process.env.REACT_APP_PUBLIC_APP_URL || 'https://app.developmentexpress.in';

const SURVEYOR_CODE_RE = /^[A-Z0-9]{1,12}$/;

export function normalizeSurveyorCode(raw) {
  const code = String(raw || '')
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, 12);
  return code;
}

export function isValidSurveyorCode(code) {
  return SURVEYOR_CODE_RE.test(code);
}

export function buildSurveyUrl(surveyType, surveyorCode, source = 'qr-card') {
  if (surveyType === 'landing') {
    return `${SURVEY_APP_ORIGIN}/survey?src=${source}&by=${surveyorCode}`;
  }
  const params = new URLSearchParams();
  params.set('src', source);
  params.set('by', surveyorCode);
  return `${SURVEY_APP_ORIGIN}/survey/${surveyType}?${params.toString()}`;
}

export function buildOwnerSurveyUrl(surveyorCode, source = 'qr-card') {
  return `${SURVEY_APP_ORIGIN}/survey/owner/type?src=${source}&by=${surveyorCode}`;
}

export function buildClientSurveyUrl(surveyorCode, source = 'qr-card') {
  return `${SURVEY_APP_ORIGIN}/survey/client/profession?src=${source}&by=${surveyorCode}`;
}

export function buildGeneralSurveyUrl(surveyorCode) {
  return buildSurveyUrl('landing', surveyorCode);
}

/** Pre-made print packs shipped in /public/survey-qr/{CODE}/ */
export const PRESET_SURVEYOR_CODES = ['OM01', 'RAJ02', 'TEST01'];

export function getPresetQrAssets(surveyorCode) {
  if (!PRESET_SURVEYOR_CODES.includes(surveyorCode)) return null;
  const base = `/survey-qr/${surveyorCode}`;
  return {
    ownerPng: `${base}/qr-owner-${surveyorCode}.png`,
    clientPng: `${base}/qr-client-${surveyorCode}.png`,
    printCardPdf: `${base}/DE-survey-card-${surveyorCode}.pdf`,
  };
}

export function downloadPublicAsset(publicPath, filename) {
  const a = document.createElement('a');
  a.href = publicPath;
  a.download = filename;
  a.rel = 'noopener';
  a.click();
}
